const baseContent = {
    type: "",
    inputType: "",
    label: "",
    data: {
        id: "",
        key: "",
        value: "",
        type: "words",
        file: {},
        isUpdated: false,
    },
    translation: {
        id: "",
        name: "",
        translationableId: "",
        translationableType: "Resource",
        adminId: "",
        languageId: "",
        flag: true,
        isUpdated: false,
    },
};

const createRegistrationFormEntry = (title: string, key: string, value: string) => ({
    title,
    content: {
        ...baseContent,
        data: {
            ...baseContent.data,
            id: "",
            key,
            value,
            type: "words",
            file: {},
            isUpdated: false,
        },
        translation: {
            ...baseContent.translation,
            id: "",
            name: "",
            translationableId: "",
            translationableType: "Resource",
            adminId: "",
            languageId: "",
            flag: true,
            isUpdated: false,
        },
    },
    isRequired: false,
    readonly: false,
    isButton: false,
});

const registrationFormEntries: { title: string, key: string, value: string }[] = [
    { title: "FIRST NAME", key: "firstName", value: "FIRST NAME" },
    { title: "LAST NAME", key: "lastName", value: "LAST NAME" },
    { title: "EMAIL", key: "email", value: "EMAIL" },
    { title: "CONFIRM EMAIL", key: "confirmEmail", value: "CONFIRM EMAIL" },
    { title: "ADDRESS", key: "address", value: "ADDRESS" },
    { title: "APT", key: "apt", value: "APARTMENT" },
    { title: "SUITE", key: "suite", value: "SUITE" },
    { title: "CITY", key: "city", value: "CITY" },
    { title: "STATE", key: "state", value: "STATE" },
    { title: "ZIPCODE", key: "zipcode", value: "ZIPCODE" },
    { title: "PHONE", key: "phone", value: "PHONE" },
    { title: "PHONE CALL", key: "phoneCall", value: "PHONE CALL" },
    { title: "PLEASE SELECT", key: "pleaseSelect", value: "PLEASE SELECT" },
    { title: "COMPANY NAME", key: "companyName", value: "COMPANY NAME" },
    { title: "HOW DID YOU HEAR ABOUT US?", key: "howDoYouHearAboutUs", value: "HOW DID YOU HEAR ABOUT US?" },
    { title: "WHAT KIND OF PRO ARE YOU", key: "whatKindOfProAreYou", value: "WHAT KIND OF PRO ARE YOU" },
    { title: "INSTALLER", key: "installer", value: "INSTALLER" },
    { title: "REMODELER", key: "remodeler", value: "REMODELER" },
    { title: "CUSTOM HOME BUILDER", key: "customHomeBuilder", value: "CUSTOM HOME BUILDER" },
    { title: "TRACT HOME OR LARGE PROJECT BUILDER", key: "tractHomeOrLanProjectBuilder", value: "TRACT HOME OR LARGE PROJECT BUILDER" },
    { title: "DESIGN AND ARCHITECTURE", key: "designAndArchitecture", value: "DESIGN AND ARCHITECTURE" },
    { title: "REALTOR", key: "realtor", value: "REALTOR" },
    { title: "INVESTOR", key: "investor", value: "INVESTOR" },
    { title: "DEVELOPER", key: "developer", value: "DEVELOPER" },
    { title: "PROPERTY MANAGER", key: "propertyManager", value: "PROPERTY MANAGER" },
    { title: "RESTORATION", key: "restoration", value: "RESTORATION" },
    { title: "OUTDOOR LIVING", key: "outdoorLiving", value: "OUTDOOR LIVING" },
    { title: "OTHER PROFESIONAL", key: "otherProf", value: "OTHER PROFESIONAL" },
    { title: "NOT A PRO", key: "notAPro", value: "NOT A PRO" },
    { title: "IN PERSON", key: "inPerson", value: "IN PERSON" },
    { title: "MAIL INVITATION", key: "mailInvitation", value: "MAIL INVITATION" },
    { title: "OTHER", key: "other", value: "OTHER" },
    { title: "I AM NOT AN EMPLOYEE", key: "iAmNotAnEmployee", value: "I AM NOT AN EMPLOYEE" },
    { title: "I confirm that I am at least 18 years of age, I am a legal U.S resident of the required states for this Sweepstakes, that i have read and aggree to the {{officialRules}}, and the terms of the {{privacyPolicy}}, and that the information I have provided is accurate, and understand if the information I provided is not accurate, my entry will be void and there will be no opportunity to win a prize.", key: "atLeast18", value: "I confirm that I am at least 18 years of age, I am a legal U.S resident of the required states for this Sweepstakes, that i have read and aggree to the ${officialRules}, and the terms of the ${privacyPolicy}, and that the information I have provided is accurate, and understand if the information I provided is not accurate, my entry will be void and there will be no opportunity to win a prize." },
    { title: "BY SUBMITTING THE INFORMATION I AGREE", key: "iAgreePromptMsg", value: "BY SUBMITTING THE INFORMATION I AGREE" },
    { title: "Privacy Policy", key: "privacyPolicy", value: "Privacy Policy" },
    { title: "official Rules", key: "officialRules", value: "official Rules" },
];

const registrationForm = registrationFormEntries.map(({ title, key, value }) => createRegistrationFormEntry(title, key, value));
export { registrationForm };








